const webpageDownload = () => {
  var pdfButton
  var initialText
  var generatingPDF = false

  $('.html-to-pdf').click(function () {
    if (generatingPDF === false) {
      generatingPDF = true
      pdfButton = $(this)
      initialText = pdfButton.html()

      pdfButton.html('Generating...')
      var filename = $(this).data('filename')
      var pdf_url = window.location.href.split('?')[0] + '?print=1'
      var prod = 'api_public_a30195b1ab6544e38192af40c9aa11b1'
      var staging = 'api_public_b36ef9a4a4c24dd19ba259087032b90c'

      SejdaJsApi.htmlToPdf({
        filename: filename + '.pdf',
        pageSize: 'a4',
        pageOrientation: 'portrait',
        publishableKey: prod,
        pageMargin: 20.2,
        pageMarginUnits: 'px',
        url: pdf_url,
        always: function () {
          pdfButton.html(initialText)
          generatingPDF = false
        },
      })
    }
  })
}

export default webpageDownload
